import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './MissioonSideCards.css';
import '../../TravelArrangements/TravelArrangementsSideCards/TravelArrangementsSideCards.css';




const MissioonSideCards = () => {
    return (
        <>
            <div className='container safetyCardContainer'>
                <div className='safetyCardBox pt-lg-5 mt-5 mb-5'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-xxl-4'>
                        <h1 className='headings mt-3  missionHeading  ps-md-0'><span>Our</span> Vision
                        </h1>
                        <p className='missionP-one'>
                            We aim to be the world’s most preferred travel companion that delivers comfort and assurance to clients worldwide. Want to live in a society where travel is easy, enjoyable, and available to everybody? That’s our goal—to make it possible for you!
                            As having expertise in the travel industry, we pay attention to offering experiences that differentiate us from our competitors.

                        </p>
                        <p className='missionP-two'><ul class="list-unstyled ">
                            <li class="mb-2">• We go outside the box to deliver extraordinary experiences to our clients.</li>
                            <li class="mb-2">• We aim to promote eco-friendliness and economical travel methods.</li>
                            <li class="mb-2">• Building a motivated and empowered workflow for all travel professionals.</li>
                            <li>• Launching a global network of enthusiastic explorers to enhance their travel experience.</li>
                        </ul></p>
                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4'>
                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/missin-side-1.png" alt="" className='safetyTravelimg mission-images' loading="lazy" />
                    </div>
                </div>

                <div className='safetyCardBoxReverse mb-5'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-xxl-4'>
                        <h1 className='headings mt-3 missionHeading  ps-md-0'><span>Our</span> Mission </h1>
                        <p className='missionP-one'>
                            At Blueberry Travel, our mission is simple: to revolutionize the way the world travels! We are strongly dedicated to delivering smooth, personalized, and sustainable travel experiences that meet the evolving needs of today’s modern travelers.
                        </p>
                        <p className='missionP-two'>Through innovation, technology, and a customized approach, we aim to enhance every journey by offering personalized solutions for business and Bleisure travel alike. Our commitment to efficiency, safety, and eco-friendliness ensures that every trip is not only unforgettable but also a responsible one. We aspire to be the trusted partner for travelers globally, turning every travel experience into an opportunity for discovery, opportunity, and growth.
                        </p>
                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex ms-5 me-xxl-5'>
                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/mission-side-2.png" alt="" className='safetyTravelimg safetyTravelimg2 mission-images ourmission' loading="lazy"  />
                    </div>
                </div>

                <div className='safetyCardBox'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-xxl-4'>
                        <h1 className='headings mt-3 missionHeading  ps-md-0'><span>Our</span> Core Values
                        </h1>
                        <p className='missionP-one'>
                            Our core values are the foundation of everything we do! These guiding principles ensure we deliver outstanding experiences to our clients, partners, and travelers. We are committed to redefining the travel industry by putting extra focus on quality, innovation, and sustainability in every aspect of our business.

                        </p>
                        <p className='missionP-two'> <div class="mb-3">
                            <p class=" mb-1"><b>Connect</b> - We promote meaningful connections with our clients and partners.</p>
                            
                        </div>
                            <div class="mb-3">
                                <p class="mb-1"><b>Deliver</b> - We ensure every traveler's journey exceeds expectations with our exceptional services.</p>
                               
                            </div>
                            <div>
                                <p class=" mb-1"><b>Evolve</b> - We continuously work and innovate to stay ahead in the travel industry.</p>
                                
                            </div></p>
                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4'>
                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/mission-side-3.png" alt="" className='safetyTravelimg mission-images' loading="lazy" />
                    </div>
                </div>



            </div>
        </>
    )
}

export default MissioonSideCards